import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBonusesConfig() {
    const CUSTOM_CONFIG = {
        Bonuses: {
            showTabSwitcher: false,
        },
        ExpandableView: {
            container: {
                style: {
                    display: 'block',
                    minWidth: '100%',
                },
            },
        },
    };

    return {
        custom: {
            [PALETTE_IDS.BONUSES]: CUSTOM_CONFIG,
        },
        palette: {
            [PALETTE_IDS.BONUSES]: {
                BONUS_ITEM_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_MEDIUM,
                },
                BONUS_ITEM_STEP_STATUS_TEXT: {
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.FOREGROUND3,
                },
            },
        },
    };
}
